import React, { useState, useEffect,  useContext } from 'react';
import './TopAlarmers.css';
import DropDown from '../DropDown/DropDown';
import { CardTopAlarmsContext } from '../../contexts/CardTopAlarmsContext';
import logComponent from '../../common/logComponent';



export default function TopAlarmersTimeRange({ updateTimeRange }) {
  const cardTopAlarmsContext = useContext(CardTopAlarmsContext);
  const [currentTimeRange, setCurrentTimeRange] = useState(null);
  const { timeRanges } = cardTopAlarmsContext;

  if (logComponent('TopAlarmersTimeRange')) { console.debug('TopAlarmersTimeRange rendered'); }

  useEffect(() => {
    if (logComponent('TopAlarmersTimeRange')) {console.debug('TopAlarmersTimeRange useEffect [cardTopAlarmsContext.topAlarmsTimeRange ]'); }
    setCurrentTimeRange(cardTopAlarmsContext.topAlarmsTimeRange);

  }, [cardTopAlarmsContext.topAlarmsTimeRange]);

  return (
    <DropDown className="Alarm-History__drop-down" items={timeRanges} selectedItem={currentTimeRange} onSelect={updateTimeRange} />
  );
}